/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate, useLocation} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {AtacanteRoutes} from './AtacanteRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'

import {SitePage} from '../pages/Site/SitePage'
import {CompanySitePage} from '../pages/Site/CompanySitePage'
import {CompanyPage} from '../pages/Company/CompanyPage'
import LoginPage from '../pages/Auth/LoginPage'

import {MasterLayout} from '../../_metronic/layout/MasterLayout'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes = ({ store, persistor }) => {
  const {currentUser} = useAuth()
  // const location :any = useLocation();
  // const background = location.state && location.state.background;

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App store={store} persistor={persistor} />}>
          <Route path='error/*' element={<ErrorsPage />} />
          {/*<Route path='logout' element={<Logout />} />*/}
          {/*<Route index element={<SitePage />} />*/}
          {/*<Route path='sistema-gestao-de-quadras' element={<CompanySitePage />} />*/}

          {/*<Route element={<MasterLayout />}>
            <Routes>
              <Route path='/sharx/*' element={<CompanyPage />} />
            </Routes>

            {background && <Route
              path="/login"
              element={<LoginPage
                  isOpen={true}
                  onClosed={() => console.log('onClosed')}
                  onLogin={() => console.log('onLogin')}
                />

              }
            />}

            <Route path='*' element={<Navigate to='/error/404' />} />
          </Route>*/}

          <Route path='/*' element={<PrivateRoutes />} />

          {/*{!currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/dashboard' />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}*/}
          {/*<Route path='/sharx' element={<AtacanteRoutes />} />*/}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
